module.exports = __webpack_public_path__ + "4b959742ccebddc6bb3715ab65c76e5a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/pencil-s.png
// module id = 2576
// module chunks = 0